<template>
    
    <footer class="bg-black">
        <div class="container">
            <div class="row pt-4 pb-4">
                <div class="col-12 col-md-4">
                    <h3 v-if="is_show_footer" class="mb-1" style="min-height:auto;">{{ $t('Follow us on') }} </h3>
                    <ul v-if="is_show_footer" class="d-flex social-icons">
                        <li><a href="https://www.facebook.com/Renkaatalle-108882470748111/" target="_blank"><i class="fab fa-facebook-square"></i></a></li>
                        <li><a href="http://www.instagram.com" target="_blank"><i class="fab fa-instagram"></i></a></li>
                        <!-- <li><a href="http://www.youtube.com" target="_blank"><i class="fab fa-youtube-square"></i></a></li>
                        <li><a href="http://www.twitter.com" target="_blank"><i class="fab fa-twitter-square"></i></a></li> -->
                    </ul>
                </div>
                <div class="col-12 col-md-4">
                        <h3 v-if="is_show_footer" class="font-weight-normal">{{ $t('Join our partner network today') }} <br/>{{ $t('and grow with us')}}.</h3>
                        <p v-if="is_show_footer" class="mb-0">
                            <router-link   
                                class="become-partner pl-5 pr-5 pt-2 pb-2"
                                :to="{ name: 'become-a-partner' }">
                                <span> {{ $t('Become a Partner') }} </span>
                            </router-link>
                        </p>
                
                </div>
                <div class="col-12 col-md-4">
                    <h3>{{ $t("Company Information") }}</h3>           
                    <p>
                        Oy Euro-Tyres Finland Ltd <br/>
                        Sipiläntie 1-3<br/>
                        12380 Leppäkoski<br/>
                        ALV numero (VAT number) FI14950197
                    </p>
                </div>
            </div>
        </div>
        <div class="container-fluid copyright-bg">
            <div class="container">
                <div class="row pt-4 pb-4">
                    <div class="col-12 col-sm-6">
                        &copy;{{ $t('All rights reserved by Oy Euro-Tyres Finland Ltd') }}
                    </div>
                    <div class="col-12 col-sm-6 text-md-right">
                        <!-- Sipiläntie 1-3 | <a href="#">Leppäkoski</a> | <a href="#">Privacy Policy</a> -->
                        
                        <!-- <template v-for="(data, index) in cmsPages">
                            <router-link v-if="data.type=='Footer'" :to="{ name: 'cmspage', params: {pagepath: data.url_path } }" :key="index">{{ data.title }}</router-link> | 
                        </template> -->
                        <router-link :to="{ name: 'cmspage', params: {pagepath: 'payment-and-delivery-terms' } }">{{ $t('Payment and delivery terms') }}</router-link> | 
                        <router-link :to="{ name: 'cmspage', params: {pagepath: 'privacy-policy' } }">{{ $t('Privacy Policy') }}</router-link> | 
                        <router-link :to="{ name: 'cmspage', params: {pagepath: 'terms-and-condition' } }">{{ $t('Terms and Condition') }}</router-link> | 
                        <router-link :to="{ name: 'cmspage', params: {pagepath: 'cookie-policy' } }">{{ $t('Cookie Policy') }}</router-link>
                        
                        <!-- <a href="#">Payment and delivery terms</a> | <a href="#">Privacy Policy</a> | <a href="#">Terms and Condition</a> | <a href="#">Cookie Policy</a> -->
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'Footer',
  created() {
    // this.getCmsPageList(['Footer'])
  },
  computed: {
        ...mapGetters("cmspage", ["cmsPages", "loading", 'isShow']),
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('HeaderFooterControl', ['is_show_footer']),
  },
  watch: {
        currentLang: {
            handler(newVal) {
                // this.getCmsPageList(['Footer'])
            }
        }
    },
  methods: {
        ...mapActions("cmspage", ["getCmsPages"]),
        getCmsPageList(pageType) {
            this.getCmsPages({pageType: pageType, lang: (this.currentLang == "fi_FI" ? 2 : 1)});
        },
    }
}
</script>
<style scoped>
/* .cp-main footer { position: relative !important; top: 78px !important; } */
</style>